<template>
  <div class="component-date">
    <Field v-slot="{ field, meta }" v-model="data" type="text" :name="name" :rules="rules">
      <input v-show="false" v-bind="field" />
      <Datepicker
        ref="dp"
        :model-value="date"
        cancel-text="Reset"
        :close-on-auto-apply="false"
        select-text="Ok"
        :month-change-on-scroll="false"
        :enable-time-picker="false"
        :format="format"
        locale="th"
        :name="name + 'Date'"
        month-name-format="long"
        :placeholder="placeholder ? placeholder : ''"
        :input-class-name="`dp-custom-input ${meta.touched && !meta.valid ? 'form-control-error' : ''}`"
        calendar-cell-class-name="dp-custom-cell"
        menu-class-name="dp-custom-menu"
        :disabled="disabled"
        :min-date="newMinDate"
        :max-date="newMaxDate"
        calendar-class-name="dp-custom-calendar"
        :day-names="['จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส', 'อา']"
        @update:modelValue="setDate"
      >
        <!--  :autoApply="true"
                  :closeOnAutoApply="true" -->
        <template #action-preview=""></template>
        <template #year="{ year }">{{ year + 543 }}</template>
        <template #year-overlay="{ value }">{{ value + 543 }}</template>
        <template #input-icon>
          <div class="group-image">
            <img class="input-slot-image" src="~@/assets/images/icon/calendar.svg" alt="calendar" />
            <img class="line" src="~@/assets/images/icon/line-up.svg" alt="calendar" />
          </div>
        </template>
      </Datepicker>
    </Field>
    <ErrorMessage v-slot="{ message }" :name="name">
      <p class="message-error">{{ message }}</p>
    </ErrorMessage>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'ComponentDate',
  props: ['name', 'placeholder', 'modelValue', 'disabled', 'rules', 'inputIcon', 'minDate', 'maxDate'],
  emits: ['update:modelValue', 'change'],
  setup(props, context) {
    const data = ref()
    const date = ref()
    const dp = ref()
    const newMinDate = ref()
    const newMaxDate = ref()
    let first = true
    const format = (date) => {
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear() + 543
      return `${day > 9 ? day : '0' + day}/${month > 9 ? month : '0' + month}/${year}`
    }
    const setDate = (value) => {
      date.value = value
      context.emit('update:modelValue', value ? format(value) : '')
      // if (!first) {
      data.value = value ? format(value) : ''
      // } else {
      // first = false
      // }
    }
    const minMaxDate = (status, value) => {
      if (status == 'minDate') {
        newMinDate.value = value
          ? new Date(+value.split('/')[2] - 543, value.split('/')[1] - 1, value.split('/')[0])
          : ''
      }
      if (status == 'maxDate') {
        newMaxDate.value = value
          ? new Date(+value.split('/')[2] - 543, value.split('/')[1] - 1, value.split('/')[0])
          : ''
      }
    }
    return {
      date,
      dp,
      format,
      setDate,
      data,
      minMaxDate,
      newMinDate,
      newMaxDate,
      first,
    }
  },
  watch: {
    minDate() {
      this.minMaxDate('minDate', this.minDate)
    },
    maxDate() {
      this.minMaxDate('maxDate', this.maxDate)
    },
    data(newData, oldData) {
      if (newData || oldData) {
        this.$emit('change', newData)
      }
    },
    modelValue() {
      if (!this.modelValue) {
        this.date = ''
        this.data = ''
      } else {
        this.setDate(
          this.modelValue
            ? new Date(
                +this.modelValue.split('/')[2] - 543,
                this.modelValue.split('/')[1] - 1,
                this.modelValue.split('/')[0]
              )
            : ''
        )
      }
    },
  },
  mounted() {
    if (this.modelValue) {
      this.setDate(
        this.modelValue
          ? new Date(
              +this.modelValue.split('/')[2] - 543,
              this.modelValue.split('/')[1] - 1,
              this.modelValue.split('/')[0]
            )
          : ''
      )
    }
    if (this.minDate) {
      this.minMaxDate('minDate', this.minDate)
    }

    if (this.maxDate) {
      this.minMaxDate('maxDate', this.maxDate)
    }
  },
}
</script>

<style lang="scss" scoped>
.group-image {
  display: flex;
  align-items: center;

  .input-slot-image {
    height: 25px;
    width: auto;
    margin: 0 5px;
  }

  .line {
    height: 35px;
  }
}
</style>
